import { PageContent } from 'components/layout/PageContent'
import React, { Dispatch } from 'react'

import { AtendimentoFooter } from '../AtendimentoFooter'

interface AtendimentoHistoricoViewProps {
  atendimentoId: ID
  isAtendimentoOdonto?: boolean
  clearCache: Dispatch<void>
}

export function AtendimentoHistoricoView(props: AtendimentoHistoricoViewProps) {
  return (
    <>
      <PageContent fluid type='filled'>
        Histórico
      </PageContent>
      <AtendimentoFooter
        atendimentoId={props.atendimentoId}
        isAtendimentoOdonto={props.isAtendimentoOdonto}
        clearCache={props.clearCache}
      />
    </>
  )
}
